export const CommonPaths = {
  splash: '/*',
  notFound: '/notFound',
  childReport: '/childReport/:childId',
  purchaseSuccess: '/payment/success',
  purchaseFailure: '/payment/failure',
  privacyPolicy: '/privacy-policy',
  termsOfService: '/terms-of-service',
};

export const UNPROTECTED_PATHS = {
  login: '/login',
};

export const PROTECTED_PATHS = {
  childProgress: '/childProgress/:childId',
  children: '/children',
  addChild: '/children/add-child',
  ListSubjectExams: '/:childId/exams',
  ListExams: '/:childId/exams/:subjectId',
  Exampdf: '/:childId/exams/:subjectId/trimester/:chapterId/pdf/:pdfId',
  chatSupport: '/:childId/chat',
  dashboard: '/:childId/dashboard',
  store: '/:childId/store',

  EXERCISES_CORRECTION: {
    pattern: '/exercises-correction/students/:childId',
    build: (studentId: number) => `/exercises-correction/students/${studentId}`,
  },

  CORRECTION_CHAPTERS: {
    pattern: '/exercises-correction/students/:childId/subjects/:subjectId/',
    build: (params: { childId: number; subjectId: number }) =>
      `/exercises-correction/students/${params.childId}/subjects/${params.subjectId}/`,
  },
  EXERCISES_CORRECTION_LIST: {
    pattern:
      '/exercises-correction/students/:childId/subjects/:subjectId/terms/:termId/chapters/:chapterId/exercises',
    build: (params: { childId: number; subjectId: number; chapterId: number; termId: number }) =>
      `/exercises-correction/students/${params.childId}/subjects/${params.subjectId}/terms/${params.termId}/chapters/${params.chapterId}/exercises`,
  },
  CORRECTION_RESULT: {
    pattern:
      '/exercises-correction/students/:childId/subjects/:subjectId/terms/:termId/chapters/:chapterId/exercises/:exerciseId/questions/:questionId',
    build: (params: {
      studentId: number;
      chapterId: number;
      exerciseId: number;
      questionId: number;
      subjectId: number;
      termId: number;
    }) =>
      `/exercises-correction/students/${params.studentId}/subjects/${params.subjectId}/terms/${params.termId}/chapters/${params.chapterId}/exercises/${params.exerciseId}/questions/${params.questionId}`,
  },
};
